import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || "";

const CustomConsumption = () => {
  const [searchParams] = useSearchParams();
  const clientCode = searchParams.get("client");

  const [prodotti, setProdotti] = useState([]);
  const [selezionato, setSelezionato] = useState("");
  const [quantita, setQuantita] = useState("");
  const [prodottiScelti, setProdottiScelti] = useState([]);
  const [messaggio, setMessaggio] = useState("");

  useEffect(() => {
    const fetchProdotti = async () => {
      const token = localStorage.getItem("access");
      const res = await fetch(`${API_URL}/api/prodotti/`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setProdotti(data);
    };
    fetchProdotti();
  }, []);

  const aggiungiProdotto = () => {
    if (!selezionato || !quantita || isNaN(quantita) || Number(quantita) <= 0) return;
    setProdottiScelti([...prodottiScelti, { name: selezionato, quantita }]);
    setSelezionato("");
    setQuantita("");
  };

  const inviaConsumo = async () => {
    const token = localStorage.getItem("access");
    const url = `${API_URL}/api/consumi/${clientCode}/aggiungi/`;

    for (const p of prodottiScelti) {
      const res = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          nome: p.name,
          quantita: p.quantita
        })
      });

      if (!res.ok) {
        const json = await res.json();
        setMessaggio(`❌ Errore su ${p.name}: ${json.detail || "Errore generico"}`);
        return;
      }
    }

    setMessaggio("✅ Tutti i consumi salvati con successo.");
    setProdottiScelti([]);
  };

  return (
    <div className="container mt-4">
      <h4>➕ Aggiungi Consumo Dettagliato</h4>
      <div className="row mb-3">
        <div className="col-md-5">
          <select
            className="form-select"
            value={selezionato}
            onChange={(e) => setSelezionato(e.target.value)}
          >
            <option value="">Seleziona prodotto</option>
            {prodotti.map((p, i) => (
              <option key={i} value={p.name}>
                {p.name} – €{p.price.toFixed(2)}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3">
          <input
            type="number"
            className="form-control"
            placeholder="Quantità"
            min="0"
            step="0.01"
            value={quantita}
            onChange={(e) => setQuantita(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <button className="btn btn-primary w-100" onClick={aggiungiProdotto}>
            Aggiungi
          </button>
        </div>
      </div>

      <ul className="list-group mb-3">
        {prodottiScelti.map((p, i) => (
          <li key={i} className="list-group-item">
            {p.name} — {p.quantita} unità
          </li>
        ))}
      </ul>

      <button className="btn btn-success w-100" onClick={inviaConsumo}>
        Salva Consumo
      </button>

      {messaggio && <div className="alert alert-info mt-3">{messaggio}</div>}
    </div>
  );
};

export default CustomConsumption;
